import * as fs from 'fs'; // using `import * as fs` instead of `import fs` : 
/*
import urlMetadata from 'url-metadata';

is syntactic sugar for

import { default as urlMetadata } from 'url-metadata';

#################################################
-->> Node modules may not have default exports
*/

function linkJSScript(shadowRoot, componentPath_URI){
    const script = document.createElement('script');
    const scriptPath = componentPath_URI.slice(0, (componentPath_URI.length - ".html".length)) + ".js";
    script.src = scriptPath;
    shadowRoot.appendChild(script);
}

function linkSCSS(shadowRoot, componentPath_URI){//TODO remplacer par une méthode sans le innerHTML brut
    // const stylePath = componentPath_URI.slice(0, (componentPath_URI.length - ".html".length)) + ".css";
    // let styleLink = `<link rel='stylesheet' type='text/css' href='${{stylePath}}'>`;
    const link = document.createElement('link');
    const stylePath = componentPath_URI.slice(0, (componentPath_URI.length - ".html".length)) + ".Scss";
    link.rel = stylePath;
    shadowRoot.appendChild(link);
}

export function linkComponentFiles(shadowRoot, componentPath_URI){
    try{
        linkJSScript(shadowRoot, componentPath_URI);
        linkSCSS(shadowRoot, componentPath_URI);
    } catch(e){
        console.error(e);
    }
}

//TODO ne opeut apparemment pas fonctionner avec parcel -> le chemin des fichiers (path) est utilisé plusieurs fois et 
// surtout dynamiquement. or, pour utiliser les fonctions du module fs de node, il faudrait obligatoirement écrire les
// noms de manière statique, parce que parcel les résout individuellement et à la build. Autrement dit, le code dynamique
// ne pourra pas fonctionner à l'exécution et en production (soit dynamique à l'exécution mais demande à node js de faire
// une recherche de fichiers depuis le client jusqu'au serv -> impossible pour sécu, soit statique mais du coup la fonction
// ne sert plus à rien)
export function findFileByName(file, path){
    /**
     * @returns {string} Path of the specified file.
     */
    try{
        const files = fs.readdirSync(path); //retourne fichiers et dossiers dans ce dossier

        for(const f of files){ // file peut être un fichier ou un répertoire 
            const filePath = path.join(path, f);
            const stat = fs.statSync(filePath); /*contient des stats y compris celle qui permet
                            de déterminer si le chemin est celui d'un dossier ou d'un fichier */

            if(stat.isDirectory()){
                //récursion ici
                const found = findFileByName(filePath, f);
                if(found){
                    return found; 
                } 
            } else if(f === filename){
                //retourne le chemin du fichier si le fichier est trouvé 
                return filePath;
            }
        }

        return null;
    }
    catch(e){
        console.error("Error in findFileByName() : " + e);
        return null;
    }
}